<div class="ligne-reservation-trajet">
	<div class="utilisateur-reservation">
		@if (reservation().prenomUtilisateur) {
			<span class="prenom">{{ reservation().prenomUtilisateur }}</span>
		}
		<span class="nom">{{ reservation().nomUtilisateur }}</span>
	</div>
	<div class="statut-reservation"
	     [style.color]="couleur()">
		<span>{{ cleTraduction() | translate }}</span>
	</div>
	<div class="info-reservation">
		@if (reservation().dateAnnulation) {
			<span class="annulee">
				{{ 'GESTION_NAVETTE.TRAJETS.DETAIL_TRAJET.RESERVATIONS.DATE_ANNULATION' | translate : { date: (reservation().dateAnnulation | date: 'dd/MM') } }}
			</span>
		} @else {
			<span class="validee">
				{{ 'GESTION_NAVETTE.TRAJETS.DETAIL_TRAJET.RESERVATIONS.DATE_RESERVATION' | translate : { date: (reservation().dateReservation | date: 'dd/MM') } }}
			</span>
		}
	</div>
</div>
